export const environment = {
    production: false,
    mode: 'DEV_ONLINE',
    backendUrl: 'https://api.dev.i-ua.nl/',
    socketSecure: false
};
